import { useAggregateResultAreaLayout } from '@upright/ui/common/upright/core/impact-lenses/net-impact/aggregate-result/layout';
import { AggregateMetricProps } from '@upright/ui/common/upright/model/output/scores/aggregate-metrics';
import { getValueSetName } from '@upright/ui/untidy/redux/selectors';
import { useSelector } from 'react-redux';
import { useNetScoreAdjustedWithValueSet } from '../use-net-score';
import { NetScoreBlock } from './index';

interface Props extends AggregateMetricProps {
  onContributeClick?: () => void;
}

export function NetScoreBlockCustom(props: Props) {
  const layout = useAggregateResultAreaLayout();
  const valueSetName = useSelector(getValueSetName);
  const netScore = useNetScoreAdjustedWithValueSet(props.currentMetric);
  return (
    <NetScoreBlock
      bounds={layout.customValueSetResultBounds()}
      netScore={netScore}
      valueSetName={valueSetName}
      {...props}
    />
  );
}
